import { get } from "./http.service";
import { getQueryParams } from "../utils/utils";

const DowntimeReport = {
  searchDowntimeReport: query => get(`downtime/search`, { params: getQueryParams(query) }),
};
export default DowntimeReport;
